import React from "react";
import { QuoteForm } from "./QuoteForm";
const steps = [{
  title: "Vous décrivez votre besoin",
  text: "Références, volumes, contraintes réglementaires."
}, {
  title: "Nous chiffrons sous 48 h",
  text: "Prix dégressifs, délais et documentation associée."
}, {
  title: "Vous validez sur échantillon",
  text: "Issu du lot réservé pour votre production."
}];
export function QuoteSection() {
  return <section id="devis" aria-labelledby="quote-title" className="scroll-mt-20 bg-sand" data-id="element-273" data-mp="2sfrspwrk16sn">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 py-24 md:px-10 md:py-32 lg:grid-cols-12" data-id="element-274" data-mp="2xfmi1vvolobl">
        <div className="lg:col-span-5" data-id="element-275" data-mp="2jg4pr6j6fsxh">
          <h2 id="quote-title" className="font-display text-5xl leading-[1.02] tracking-tight text-ink md:text-6xl" data-id="element-276" data-mp="2jf20t45f00k7">
            Parlons de votre prochaine formule.
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-olive" data-id="element-277" data-mp="17zdd2akc6xic">
            Un chargé de compte dédié étudie chaque demande, de l'échantillon de laboratoire au contrat de culture
            pluriannuel.
          </p>

          <ol className="mt-12 space-y-8" data-id="element-278" data-mp="2tw1oi9r9ubzv">
            {steps.map((s, i) => <li key={s.title} className="grid grid-cols-[36px_1fr] gap-4" data-id="element-279" data-mp="2owozpjguauun" data-mpi={i}>
                <span className="flex h-9 w-9 items-center justify-center rounded-full border border-olive/40 font-display text-lg text-olive" data-id="element-280" data-mp="33t6d0g8lajju">
                  {i + 1}
                </span>
                <div data-id="element-281" data-mp="3crrpbtngx2c6">
                  <p className="font-medium text-ink" data-id="element-282" data-mp="3cr8ip939q0dg">{s.title}</p>
                  <p className="mt-1 text-sm text-olive/80" data-id="element-283" data-mp="37ui1gifq8yqg">{s.text}</p>
                </div>
              </li>)}
          </ol>

          <div className="mt-12 border-t border-olive/20 pt-6 text-sm text-olive" data-id="element-284" data-mp="3mhupcdt0bgk0">
            Vous préférez en parler ?{" "}
            <a href="tel:+33490000000" className="font-medium text-ink underline-offset-4 hover:underline" data-id="element-285" data-mp="3vjasc0hhsge7">
              +33 4 90 00 00 00
            </a>
            <span className="block text-olive/70" data-id="element-286" data-mp="3rjadwfue8575">Du lundi au vendredi, 8 h 30 – 18 h</span>
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-287" data-mp="2df1d262bg7t">
          <QuoteForm data-id="element-288" data-mp="7e32whrx3fga" />
        </div>
      </div>
    </section>;
}